<!-- eslint-disable max-len -->
<template>
  <div id="modal-token-a3" class="modal modal-lg fade" tabindex="-1">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <button
            class="btn-close"
            type="button"
            data-bs-dismiss="modal"
            aria-label="Fechar"
          ></button>
        </div>
        <div class="modal-body">
          <div class="modal-token-a3-body">
            <div class="modal-token-a3-fields"></div>
            <h4 v-if="stepModal === 1 || stepModal === 2">
              Vamos te ajudar a fazer o download do Driver <br />
              referente ao seu Token!
            </h4>
            <h4 v-else>Aguarde enquanto o download é concluído</h4>
            <ul
              v-if="stepModal !== 3"
              class="nav nav--wizard my-4 d-flex flex-row justify-content-center"
            >
              <li
                class="nav-item"
                :class="[
                  stepModal === 2 ? 'nav--wizard__nav-item--success' : '',
                ]"
              >
                <a
                  class="nav-link"
                  content="1"
                  :class="[
                    stepModal === 1 ? 'active' : '',
                    stepModal === 2 ? 'disabled' : '',
                  ]"
                  >Selecione o modelo do Chip</a
                >
              </li>
              <li class="nav-item">
                <a
                  class="nav-link"
                  content="2"
                  :class="[stepModal === 2 ? 'active' : '']"
                  >Selecione o Sistema Operacional</a
                >
              </li>
            </ul>
            <div v-if="stepModal === 1" class="token-choice">
              <p>Em qual Token está armazenado seu Certificado Digital?</p>
              <div class="form-token d-flex flex-row justify-content-center">
                <div class="form-check">
                  <input
                    id="radioFeithian"
                    v-model="tokenChoice"
                    class="form-check-input form-check-input--success"
                    type="radio"
                    name="radioToken"
                    value="Feithian"
                    checked
                  />
                  <label class="form-check-label" for="radioFeithian"
                    >Feithian</label
                  >
                </div>
                <div class="form-check ms-3">
                  <input
                    id="radioSafenet"
                    v-model="tokenChoice"
                    class="form-check-input form-check-input--success"
                    type="radio"
                    name="radioToken"
                    value="Safenet"
                  />
                  <label class="form-check-label" for="radioSafenet"
                    >Safenet</label
                  >
                </div>
                <div class="form-check ms-3">
                  <input
                    id="radioDXSafe"
                    v-model="tokenChoice"
                    class="form-check-input form-check-input--success"
                    type="radio"
                    name="radioToken"
                    value="DXSafe"
                  />
                  <label class="form-check-label" for="radioDXSafe"
                    >DXSafe</label
                  >
                </div>
                <div class="form-check ms-3">
                  <input
                    id="radioGD"
                    v-model="tokenChoice"
                    class="form-check-input form-check-input--success"
                    type="radio"
                    name="radioToken"
                    value="GD"
                  />
                  <label class="form-check-label" for="radioGD">G+D</label>
                </div>
              </div>
              <p class="mt-2">
                Compare o <strong>modelo do seu Token</strong> para selecionar o
                driver correto
              </p>
              <div class="img-tokens">
                <img
                  :class="tokenChoice == 'Feithian' ? 'show-img' : 'hide-img'"
                  src="@/assets/images/Feithian.svg"
                  alt="Imagem de um token Feithian"
                />
                <img
                  src="@/assets/images/safeNet.svg"
                  alt="Imagem de um token Safenet"
                  :class="tokenChoice == 'Safenet' ? 'show-img' : 'hide-img'"
                />
                <img
                  src="@/assets/images/DXToken.svg"
                  alt="Imagem de um token DXSafe"
                  :class="tokenChoice == 'DXSafe' ? 'show-img' : 'hide-img'"
                />
                <img
                  src="@/assets/images/GD.png"
                  alt="Imagem de um token G+D"
                  :class="tokenChoice == 'GD' ? 'show-img' : 'hide-img'"
                  height="96"
                />
              </div>
            </div>
            <div v-if="stepModal === 2" class="os-choice">
              <p>Escolha abaixo o Sistema Operacional do seu computador</p>
              <div class="os-choice__images my-5">
                <button
                  type="button"
                  @click="operationalSystem = 'windowsOSSelected'"
                >
                  <img :src="windowsChecked" alt="Logo do Windows" />
                </button>
                <button
                  type="button"
                  @click="operationalSystem = 'macOSSelected'"
                >
                  <img :src="macChecked" alt="Logo do MacOS" />
                </button>
                <button
                  type="button"
                  @click="operationalSystem = 'linuxOSSelected'"
                >
                  <img :src="linuxChecked" alt="Logo do Linux" />
                </button>
              </div>
              <div class="driver-choice d-flex flex-column">
                <p v-if="drivers.length > 0" class="text-start">
                  Agora selecione a Versão
                </p>
                <Selectable
                  v-show="drivers.length > 0"
                  :key="selectableCount"
                  v-model="driverChoice"
                  :options="drivers"
                  label=""
                  name="index"
                  icon="download"
                  label-selectable="nome"
                  placeholder="Selecione o driver"
                >
                </Selectable>
              </div>
            </div>
            <div
              v-if="stepModal === 3"
              class="final-modal-token d-flex flex-column justify-content-center"
            >
              <div class="d-flex flex-row justify-content-center">
                <img
                  class="my-3"
                  src="@/assets/images/download.gif"
                  alt="Gif animado de download"
                />
              </div>
              <p class="text-start my-3"><strong>Importante</strong></p>
              <p class="text-start d-flex flex-row">
                <Icon class="icon-check" name="circle-check"></Icon
                ><span
                  >Enquanto isso, certifique-se de que sua mídia esteja
                  <strong>desconectada</strong> do seu computador para
                  prosseguir com a instalação.</span
                >
              </p>
              <p class="text-start d-flex flex-row">
                <Icon class="icon-check" name="circle-check"></Icon
                ><span
                  >Após a conclusão do Download, execute o arquivo instalado e
                  avance as etapas até concluir a instalação do programa.</span
                >
              </p>
              <p class="text-start d-flex flex-row">
                <Icon class="icon-check" name="circle-check"></Icon
                ><span
                  >Após a instalação do programa,
                  <strong>insira a mídia no computador.</strong></span
                >
              </p>
              <p class="text-start d-flex flex-row">
                <Icon class="icon-check" name="circle-check"></Icon
                ><span
                  >Em seguida,
                  <a :href="getLinkEmissor">faça o download do emissor</a> e
                  siga os passos até a conclusão da instalação e a gravação dos
                  dados do Certificado Digital em sua mídia.</span
                >
              </p>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <div class="row">
            <p v-if="hasDriversAndNoHasOS" class="col-5 text-danger text-start">
              Não há driver encontrado para este Sistema Operacional
            </p>
            <div
              class="text-end"
              :class="hasDriversAndNoHasOS ? 'col-7' : 'col-12'"
            >
              <button
                v-if="stepModal === 2"
                class="btn btn-outline-primary"
                type="button"
                @click="stepModal--"
              >
                Voltar
              </button>
              <button
                v-if="stepModal === 1 || stepModal === 2"
                class="ms-2 btn btn-primary"
                :class="getColorButton"
                :disabled="driverChoice === '' && stepModal === 2"
                type="button"
                @click="downloadDriver"
              >
                <span v-if="stepModal === 1">Avançar</span
                ><span v-if="stepModal === 2">Fazer download do drive</span>
                <Icon v-if="stepModal === 1" class="ms-2" name="arrow-right" />
                <Icon v-if="stepModal === 2" class="ms-2" name="download" />
              </button>
              <a
                v-if="stepModal === 3"
                class="me-2 btn btn-outline-primary"
                href="/ManualEmissaoA3.pdf"
                target="_blank"
                type="button"
              >
                <Icon class="me-2" name="up-right-from-square" />
                <span>Abrir guia de instalação</span>
              </a>
              <a
                v-if="stepModal === 3"
                class="btn btn-primary"
                :href="getLinkEmissor"
                target="_blank"
                type="button"
                ><span>Baixar emissor</span>
                <Icon class="ms-2" name="download"></Icon>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <button
    class="btn-desktop btn btn-primary mt-3"
    type="button"
    data-bs-target="#modal-token-a3"
    data-bs-toggle="modal"
    @click="stepModal = 1"
  >
    <Icon class="me-2" name="download"></Icon><span>Baixar driver</span>
  </button>
</template>

<script lang="ts">
  import { defineComponent } from 'vue'
  import Icon from '@/components/Atoms/Icon.vue'
  import Selectable from '@/components/Atoms/Selectable.vue'
  import drivesTokenJson from '@/store/JSON/drivesTokenJson'
  import { mapState } from 'pinia'
  import { useAR } from '@/store/Pinia/useAR.store'

  import windowsOSImg from '@/assets/images/windows-black.svg'
  import windowsOSSelectedImg from '@/assets/images/windows-blue.svg'
  import macOSImg from '@/assets/images/mac-black.svg'
  import macOSSelectedImg from '@/assets/images/mac-blue.svg'
  import linuxOSImg from '@/assets/images/linux-black-eo.svg'
  import linuxOSSelectedImg from '@/assets/images/linux-blue.svg'

  interface IObjectDrive {
    nome: string
    link: string
    type: string
  }

  export default defineComponent({
    name: 'ModalTokenComponent',
    components: {
      Icon,
      Selectable,
    },
    data: () => ({
      stepModal: 1,
      tokenChoice: 'Feithian',
      operationalSystem: '',
      windowsOS: windowsOSImg,
      windowsOSSelected: windowsOSSelectedImg,
      macOS: macOSImg,
      macOSSelected: macOSSelectedImg,
      linuxOS: linuxOSImg,
      linuxOSSelected: linuxOSSelectedImg,
      driverChoice: '',
      selectableCount: 0,
      link: '',
      drivers: [],
    }),
    methods: {
      downloadDriver() {
        if (this.stepModal === 2) {
          window.open(this.link)
        }
        this.stepModal += 1
      },
    },
    computed: {
      ...mapState(useAR, ['getLinkEmissor']),
      getColorButton() {
        if (this.stepModal === 1) {
          return 'btn-primary'
        }
        if (this.driverChoice === '' && this.stepModal === 2) {
          return 'btn-secondary'
        }
        return 'btn-primary'
      },
      isFeithian() {
        return this.tokenChoice === 'Feithian'
      },
      isSafenet() {
        return this.tokenChoice === 'Safenet'
      },
      isDXSafe() {
        return this.tokenChoice === 'DXSafe'
      },
      windowsChecked() {
        if (this.operationalSystem === 'windowsOSSelected') {
          return this.windowsOSSelected
        }
        return this.windowsOS
      },
      macChecked() {
        if (this.operationalSystem === 'macOSSelected') {
          return this.macOSSelected
        }
        return this.macOS
      },
      linuxChecked() {
        if (this.operationalSystem === 'linuxOSSelected') {
          return this.linuxOSSelected
        }
        return this.linuxOS
      },
      hasDriversAndNoHasOS() {
        return this.drivers.length === 0 && this.operationalSystem !== ''
      },
    },
    watch: {
      stepModal(curr: number) {
        if (curr === 1) {
          this.operationalSystem = ''
          this.drivers = []
        }
      },
      operationalSystem(
        current: 'linuxOSSelected' | 'macOSSelected' | 'windowsOSSelected',
      ) {
        if (current) {
          const drivers = drivesTokenJson[current]
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          this.drivers = drivers.filter(
            (x) => x.type === this.tokenChoice,
          ) as any
          this.selectableCount += 1
          this.driverChoice = ''
        }
      },
      driverChoice(current) {
        const objectDrive = this.drivers.find(
          (x: IObjectDrive) => x.nome === current,
        ) as IObjectDrive | undefined
        if (objectDrive) {
          this.link = objectDrive.link
        }
      },
    },
  })
</script>

<style lang="stylus" scoped>
  .hide-img
    opacity: 0
    width: 0
    transform: scale(0.5)
  .show-img
    opacity: 1
    transform: scale(1)
    transition: all 0.2s ease-in

  .os-choice
    &__images
      display: flex
      justify-content: center
      align-items: center
      gap: 2.5rem

      > button
        background: none
        border: none

  .img-tokens
    min-height: 100px

  .final-modal-token
    span
      a
        text-decoration: underline
        font-weight: 700
  .icon-check
    color: var(--color-success-600)
    margin-right: 0.5rem
  .btn-desktop
    display: block !important

  @media screen and (max-width: 768px)
    .btn-desktop
      display: none !important
</style>
